<template lang="pug">
  div.properties
    div.md-layout.md-gutter(v-if="issetData()")
      div.input-field.md-layout-item(v-for="(property, key) in propertyValues" v-bind:key="property.id" v-bind:class=" 'property-item ' + property.class + ' md-size-' + property.size")
        md-field(v-if="property['multiply'] != 1 && !(['checkbox', 'radio', 'select', 'file'].indexOf(property['field_type']) + 1)" v-bind:class="(property['valid']) ? '' : 'md-invalid' ")
          label(v-if="!property.require" v-bind:for="('property-' + property.code)") {{property.name}}
          label(v-if="property.require" v-bind:for="('property-' + property.code)") {{property.name + ' *'}}
          md-input(v-bind:disabled="$props.disabled"   v-if='(property["field_type"] === "text")'     v-model="property['value']" v-bind:name="property.code" v-bind:id="'property-' + property.code" v-on:input="FieldChange(property.code)")
          md-input(v-bind:disabled="$props.disabled"   v-if='(property["field_type"] === "number")'   v-model="property['value']" v-bind:name="property.code" v-bind:id="'property-' + property.code"  type="number" v-on:input="FieldChange(property.code)")
          md-textarea(v-bind:disabled="$props.disabled" v-if='(property["field_type"] === "textarea")' v-model="property['value']" v-bind:name="property.code" v-bind:id="'property-' + property.code" v-on:input="FieldChange(property.code)")
          span.md-error(v-show="!property['valid']") Проверьте корректность вводимых данныx

        div(v-if="property['multiply'] == '1' && !(['checkbox', 'radio', 'select', 'file'].indexOf(property['field_type']) + 1)" v-for="(value, i) in property['value']")
          md-field(v-bind:class=" (property['valid'][i] ? '' : 'md-invalid') ")
            label {{property.name + ' ' + (i + 1)}}
            md-input(v-bind:disabled="$props.disabled"   v-if='(property["field_type"] === "text")'     v-model="property['value'][i]" v-bind:name="property.code" v-bind:id="'property-' + property.code + '-' + (i+1)" v-on:input="FieldChange(property.code)")
            md-input(v-bind:disabled="$props.disabled"   v-if='(property["field_type"] === "number")'   v-model="property['value'][i]" v-bind:name="property.code" v-bind:id="'property-' + property.code + '-' + (i+1)" type="number" v-on:input="FieldChange(property.code)")
            md-textarea(v-bind:disabled="$props.disabled" v-if='(property["field_type"] === "textarea")' v-model="property['value'][i]" v-bind:name="property.code" v-bind:id="'property-' + property.code + '-' + (i+1)" v-on:input="FieldChange(property.code)")
            md-button.md-icon-button.md-dense(v-if="i > 0" v-on:click="property['value'].splice(i, 1); property['valid'].splice(i, 1); property['changed'] = 1;"): md-icon close
            md-button.md-icon-button.md-dense(v-on:click="property['value'].push(null); property['valid'].push(1); property['changed'] = 1;"): md-icon add
            span.md-error(v-show="!property['valid']") Проверьте корректность вводимых данныx

        div(v-if="property['field_type'] === 'radio' && property.choices.length > 1")
          label {{property.name}}
          div(v-for="(choices, i) in property.choices")
            z-check(
              v-bind:label="choices.name"
              v-bind:id="('service-' + choices.code)"
              v-model="property['value']"
              v-bind:value="choices.code"
              v-bind:disabled="$props.disabled"
            )

        div(v-if="property['field_type'] === 'select' && property.choices.length > 1")
          md-field
            label {{property.name}}
            md-select(v-bind:disabled="$props.disabled" v-model="property['value']" v-bind:name="property.code"  v-bind:id="'property-' + property.code" v-on:click="FieldChange(property.code)")
              md-option(v-for="(choices, i) in property.choices" v-bind:key="i" v-bind:value="choices.code") {{choices.name}}

        div(v-if="property['field_type'] === 'checkbox'")
          label(v-if="(property.choices.length > 1)") {{property.name}}
          div(v-for="choices in property.choices")
            md-switch(v-bind:disabled="$props.disabled"  v-if="(property.choices.length == 1)" v-model="property['value']" v-bind:value="choices.code" v-on:change="FieldChange(property.code)") {{property.name}}
            md-checkbox(v-bind:disabled="$props.disabled" v-if="(property.choices.length > 1)"  v-model="property['value']" v-bind:value="choices.code" v-on:change="FieldChange(property.code)") {{choices.name}}

        div(v-if="property['field_type'] === 'file'")
          div.file-container
            div.md-layout-item
              md-field
                label {{property.name}}
                md-file(v-bind:disabled="$props.disabled" v-if="(property.multiply != '1')" v-bind:name="property.code" v-bind:id="'property-' + property.code"  v-model="property['value']" v-on:change="changeFile")
                md-file(v-bind:disabled="$props.disabled" v-if="(property.multiply == '1')" v-bind:name="property.code" v-bind:id="'property-' + property.code"  v-model="property['value']" v-on:change="changeFile" multiple)
            div.md-flex.file-card-container(v-if="Object.keys(files).length && Object.keys(files[property.code]).length")
              md-card.image-container(v-for="file in files[property.code]" v-bind:key="file.id")
                md-card-media(md-ratio="16:9" v-if="file.image")
                  img(v-bind:src="file.path")
                md-card-area
                  md-card-header
                    div.md-title {{file.name}}
                    span.md-subhead {{file.size}}
                    span.md-subhead {{', Формат: ' + file.file_type}}
                    div.md-subhead(v-if="file && file['uploader']") {{'Загрузил: ' + file['uploader']['login'] + ' (' + moment(file['created_at']).format('DD.MM.YYYY HH:mm:ss') + ')' }}
                  md-card-actions
                    span
                      md-button.md-icon-button.md-dense(v-on:click="openFile(file.path)"): md-icon loupe
                      md-tooltip(md-direction="top" md-delay="300") {{openFileTooltip}}
                    span
                      md-button.md-icon-button.md-dense(@click="removeFile(property, file['id'])"): md-icon close
                      md-tooltip(md-direction="top" md-delay="300") {{deleteFileTooltip}}
    div(v-if="!issetData()")
      span Не указан один из обязательных параметров компонента либо не верен его формат
</template>

<script>
  import ZCheck from '@/components/ZCheck';
  export default {
    name: 'properties',
    props: [
      'module',
      'entity',
      'properties',
      'id',
      'entity_id',
      'disabled'
    ],
    components: {ZCheck},
    data() {
      return {
        openFileTooltip: 'Открыть файл в новой вкладке',
        saveFileTooltip: 'Сохранить файл',
        deleteFileTooltip: 'Удалить файл',
        values: {},
        files: {},
        newFiles: {},
        propertyValues: {}
      }
    },
    created() {
      if (this.issetData()) this.getProperties();
      this.$root.$on('submit-properties', (id, entity_id) => this.submitProperties(id, entity_id));
    },
    watch: {
      '$props.entity_id'() {
        this.getProperties();
      }
    },
    computed: {},
    methods: {

      submit(entity_id) {
        return this.submitProperties(this.$props.id, entity_id);
      },

      startProperty(val) {
        if (!val || !val.length) return;

        let that = this, propertyValues = {};
        if (this.issetData() && Object.keys(val).length) {
          let inputedProperties;
          if (typeof that.properties == 'array') {
            inputedProperties = that.properties;
          } else if (typeof that.properties == 'object') {
            inputedProperties = Object.keys(that.properties);
          }

          val.map(function (property) {
            property.class = '';
            //если у свойства нет начальных значений, то установим их
            if (!property.value || (typeof property.value === 'object' && !Object.keys(property.value).length) ) {
              let tempValue;
              tempValue = null;
              //начальные значения полей
              if (property['multiply'] == '1') {
                if (property["field_type"] === 'checkbox') {
                  tempValue = [];
                } else if (property["field_type"] === 'radio' || property["field_type"] === 'file') {
                  tempValue = null;
                } else {
                  tempValue = [null];
                }
              }
              property.value = tempValue;
            } else {
              if (property['field_type'] == 'file') {
                that.files[ property['code'] ] = property['files'];
              }
            }

            //установим флаг о том, что свойства не изменялись
            property['changed'] = 0;
            //установим флаг валидности
            property['valid'] = 1; //для одиночных свойств
            if (property['multiply'] == '1' && !((['file', 'checkbox', 'radio', 'select']).indexOf(property['field_type']) + 1)) { //для множественных
              property['valid'] = [];
              Object.keys(property.value).map((value, i) => {
                property['valid'][i] = 1;
              });
            }

            //если передали массив с полями, то выводим только те, что запросили
            if(inputedProperties && Object.keys(inputedProperties).length) {
              if ((inputedProperties.indexOf(property.code) + 1)) {
                //если передали объект с классами, значит добавляем их
                if (typeof that.properties == 'object') {
                  property.class = that.properties[property.code]['class'];
                }
                propertyValues[property.code] = Object.assign({}, property);
              }
            } else { //иначе выводим все поля
              propertyValues[property.code] = Object.assign({}, property);
            }
          });
        }
        this.propertyValues = Object.assign({}, propertyValues);
      },
      openFile(url) {
        let win = window.open(url, '_blank');
        win.focus();
      },
      removeFile(property, value) {
        this.$store.dispatch(
          'module/removeModuleEntitiesPropertyValuesFile',
          {value: value, property_id: property['id']}
          ).then(response => {
            this.getProperties();
            }, response => {
            this.$store.commit('handleSnackError', [response, 6000, 'error']);
          });
      },
      getProperties() {
        this.$store.dispatch(
          'module/getModuleEntitiesProperties',
          {module_code: this.$props.module, entity_code: this.$props.entity, entity_id: this.$props.entity_id}
        ).then(response => {
          response = response.body.response;
          if (response && response.length) this.startProperty(response);
        }, response => {
          this.$store.commit('handleSnackError', [response, 6000, 'error']);
        });
      },

      submitProperties(id, entity_id) {
        if (!this.propertyValues || !Object.keys(this.propertyValues).length) return;

        if (
          !entity_id || typeof entity_id !== 'number' ||
          !id || typeof id !== 'string' || id != this.$props.id || !this.validate()
        ) {
          let rejectTest = false;
          this.$emit('submit', {success: false, response: false, message: 'Проверьте корректность заполнения полей.'});
          this.$emit('submit-properties-end', {success: false, response: false, message: 'Проверьте корректность заполнения полей.'});

          return new Promise((resolve, reject) => {
            reject({success: false, response: false, message: 'Проверьте корректность заполнения полей.'});
          });

        } else {
          let values = JSON.parse(JSON.stringify(this.propertyValues)), that = this, data = new FormData();
          Object.keys(values).map(function (key) {
            let property = values[key];
            if (!property['changed']) { //если свойство не изменялось, то не отправляем его
              delete values[key];
            } else {
              values[key]['property_id'] = values[key]['id'];
              values[key]['entity_id'] = entity_id;
              if (property["field_type"] == 'file') {
                for (let i = 0; i < that.newFiles[property.code].length; i++) {
                  data.append(key + '[]', that.newFiles[property.code][i]);
                }
              } else {
                data.append(key, values[key]['value']);
              }
            }
          });
          data.append('_request_meta_data', JSON.stringify(values));

          return this.$store.dispatch('module/setModuleEntitiesPropertyValues', data).then((response) => {
            this.getProperties();
            let resp = '';
            if (response && response.body && response.body.errors) resp = response.body.errors.messages;
            
            this.$emit('submit', {success: true, response: resp, message: ''});
            this.$emit('submit-properties-end', {success: true, response: resp, message: ''});

          return {success: true, response: resp, message: ''};
          }, response => {
            this.$store.commit('handleSnackError', [response, 6000, error]);
            let resp = '';
            if (response && response.body && response.body.errors) resp = response.body.errors.messages;
            else resp = 'Произошла неизвестная ошибка. Пожалуйста перезагрузите страницу.';

            this.$emit('submit', {success: false, response: response, message: resp});
            this.$emit('submit-properties-end', {success: false, response: response, message: resp});

            return {success: false, response: response, message: resp};
          });

        }
      },
      changeFile(event) {
        const files = event.target.files, prop_code = event.target.getAttribute('name');
        if (Object.keys(files).length && prop_code) {
          this.newFiles[ prop_code ] = Object.assign(files);
          this.propertyValues[ prop_code ]['changed'] = 1;
        }
      },
      FieldChange(prop_code) {
        let value = this.propertyValues[ prop_code ];
        this.propertyValues[ prop_code ]['changed'] = 1;
        this.validate(prop_code);
      },
      validate(prop_code) {
        let that = this, valid = true;
        if (this.issetData() && Object.keys(this.propertyValues).length) {

          Object.keys(that.propertyValues).map(function (key) {
            let property = that.propertyValues[key];
            if(!prop_code || property['code'] == prop_code) {
              //если это поле ввода и оно обязательно, то проверяем валидность
              if (property['require'] == 1 && !((['file', 'checkbox', 'radio', 'select']).indexOf(property['field_type']) + 1) ) {
              let validateValue;
              if (property['multiply'] == 1) { //если поле множественное
                validateValue = property['value'][0];
                property['value'].map((value, i) => {
                  //проверяем валидность
                  if ( value == null || value.length <= 0  ) {
                    that.propertyValues[key]['valid'][i] = 0;
                    valid = false;
                  } else {
                    that.propertyValues[key]['valid'][i] = 1;
                  }

                });

              } else { //если поле одиночное
                validateValue = property['value'];
                //проверяем валидность
                if (validateValue == null || validateValue.length <= 0  ) {
                  that.propertyValues[key]['valid'] = 0;
                  valid = false;
                } else {
                  that.propertyValues[key]['valid'] = 1;
                }
              }
            }
            }
          });
        }
        return valid;
      },
      issetData() {
        return (
          this.$props.id &&
          this.$props.module &&
          this.$props.entity &&
          typeof this.$props.id === 'string' &&
          typeof this.$props.module === 'string' &&
          typeof this.$props.entity === 'string'
        );
      }
    }
  }
</script>
<style scoped lang="sass" src="../assets/sass/properties.sass"></style>



// WEBPACK FOOTER //
// Properties.vue?60ef19ff